"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useViewportSize = useViewportSize;
exports.default = void 0;

var _react = require("react");

var _ = require("../..");

/**
 * useViewportSize - This hook returns an object containing the height and
 * width values for the current size of the viewport. If the user resizes the
 * browser window, it will return updated values. These values are debounced
 * to avoid unnecessarily frequent updates.
 */
function useViewportSize() {
  const {
    innerHeight,
    innerWidth
  } = window;
  const [height, setHeight] = (0, _.useDebounce)(innerHeight, 300);
  const [width, setWidth] = (0, _.useDebounce)(innerWidth, 300);

  const handleResize = () => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);
  };

  (0, _react.useEffect)(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize); // Empty deps to ensure eventlistener is only inititialized on mount.
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    height,
    width
  };
}

var _default = useViewportSize;
exports.default = _default;
//# sourceMappingURL=useViewportSize.js.map